module.exports = __webpack_public_path__ + "img/video_games.7b73022c.svg";